import React, { Component } from 'react';
import Exhibit from "components/exhibit/Exhibit.js";
import IPFSDownloader from 'components/download/IPFSDownloader.js';
import axios from 'axios';
import Sound from './components/Sound.js';
import ExplorePage from './components/explore/ExplorePage.js';
import Uploader from './components/upload/Uploader.js';
import Sequencer from './components/v2/Sequencer.js';
import ExportFull from './components/headless/ExportFull.js';
import GuildsPage from './components/guilds/GuildsPage.js';
import LandingPage from './components/landing/LandingPage.js';
import PinnerComponent from './components/PinnerComponent.js';
import SamplePacksComponent from './components/samplepacks/SamplePacksComponent.js';
import UserComponent from 'components/user/UserComponent.js';
import TagsOrganizerComponent from './components/tags/TagsOrganizerComponent.js';
import SequencesView from './components/SequencesView.js';
import Downloader from './downloader.js';
import AudioRecorder from './recorderWorker.js';
import recorderWorker from './recorderWorker.js';
import 'bootstrap/dist/css/bootstrap.css';
import { StaticRouter, withRouter, Route, Switch } from 'react-router-dom';
import { BrowserRouter } from 'react-router-dom';
import { Badge, Label, Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import SoundUpload from './components/SoundUpload.js';
import Discover from './components/discover/Discover.js';

import logo from './logo.svg';
import './App.css';

class App extends Component {
    constructor(props) {
        super(props);
    }

   render() {
        return (
                <BrowserRouter>
                <Switch>
                  <Route  path="/user/:userId"
                          render={(props) => <UserComponent {...props} store={this.props.store}/>}/>
                  <Route  path="/user/"
                          render={(props) => <UserComponent {...props} store={this.props.store}/>}/>
                  <Route  path="/exhibit/:sequenceId"
                          render={(props) => <Exhibit {...props} store={this.props.store}/>}/>
                  <Route  path="/exhibit/"
                          render={(props) => <Exhibit {...props} store={this.props.store}/>}/>
                <Route  path="/sequencer/:sequenceId" 
                        render={(props) => <Sequencer {...props} store={this.props.store}/>}/>
                <Route  path="/explore/:sequenceId" 
                        render={(props) => <ExplorePage {...props} store={this.props.store}/>}/>
                <Route  path="/explore/" 
                        render={(props) => <ExplorePage {...props} store={this.props.store}/>}/>
                <Route  path="/create/:sequenceId" 
                        render={(props) => <Sequencer {...props} store={this.props.store}/>}/>
                <Route  path="/exportfull/:sequenceId" 
                        render={(props) => <ExportFull {...props} store={this.props.store}/>}/>
                <Route  path="/fast/:sequenceId" 
                        render={(props) => <Sequencer {...props} fastCreate={true} store={this.props.store}/>}/>
                <Route  path="/guilds/"
                        render={(props) => <GuildsPage {... props} store={this.props.store}/>}
                  />
                <Route  path="/packs/"
                        render={(props) => <SamplePacksComponent {...props} store={this.props.store}/>}/>
                  <Route  path="/tags/"
                          render={(props) => <TagsOrganizerComponent {... props} store={this.props.store}/>}/>
                <Route  path="/sequencer/"
                        render={(props) => <Sequencer {...props} store={this.props.store}/>}/>
                <Route  path="/create/"
                        render={(props) => <Sequencer {...props} store={this.props.store}/>}/>
                <Route  path="/download/"
                        render={(props) => <IPFSDownloader {...props} store={this.props.store}/>}/>
                <Route  path="/fast/"
                        render={(props) => <Sequencer {...props} fastCreate={true} store={this.props.store}/>}/>
                <Route  path="/upload/"
                        render={(props) => <SoundUpload {...props} store={this.props.store}/>}/>
                <Route  path="/uploader/"
                        render={(props) => <Uploader {...props} store={this.props.store}/>}/>
                <Route  path="/discover/"
                        render={(props) => <Discover {...props} store={this.props.store}/>}/>
                  {/*<Route  path="/"
                     render={(props) => <LandingPage {...props} store={this.props.store}/>}/> */}
                <Route  path="/"
                     render={(props) => <Exhibit {...props} store={this.props.store}/>}/>
                <Route  path="/documentation"
                        render={(props) => <LandingPage {...props} showDocumentation={true} store={this.props.store}/>}/>
                </Switch>
                </BrowserRouter>
                );
    }
}

export default App;

function getLink(videoId) {
    return "https://www.youtube.com/watch?v=" + videoId;
}

